module.exports = __webpack_public_path__ + "img/place16.bb15f32b.jpg";